import { http } from '@/http/axios.js'

// 列表
export function pageAPI(params) {
  return http({
    url: `/api/manage/staff/biaoxun_lock/page`,
    method: 'get',
    params
  })
}

// 详情
export function getDetailAPI(id) {
  return http({
    url: `/api/manage/staff/biaoxun_lock/detail`,
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: `/api/manage/staff/biaoxun_lock/add`,
    method: 'post',
    data
  })
}
// 编辑
export function editAPI(data) {
  return http({
    url: `/api/manage/staff/biaoxun_lock/edit`,
    method: 'post',
    data
  })
}
// del
export function delAPI(id) {
  return http({
    url: `/api/manage/staff/biaoxun_lock/del`,
    method: 'post',
    data: { id }
  })
}

export function editDisplayAPI(data)
{
  return http({
    url: `/api/manage/staff/biaoxun_lock/edit`,
    method: 'post',
    data
  })
}


export function treeDeptWithUserAPI()
{
  return http({
    url: `/api/manage/staff/biaoxun_lock/treeWithEmployee`,
    method: 'get',
  })
}
